import { Subject } from 'rxjs';

export class GMapsCustomPopup extends window.google.maps.OverlayView {
	private position: google.maps.LatLng;
	private containerDiv: HTMLDivElement;
	private clickEventSubject: Subject<MouseEvent>;

	constructor(position, content) {
		super();
		this.position = position;
		this.clickEventSubject = new Subject<MouseEvent>();

		const contentDiv = document.createElement('div');
		contentDiv.innerHTML = content;
		contentDiv.classList.add('popup-bubble');
		contentDiv.addEventListener('click', (e) => {
			this.clickEventSubject.next(e);
		});

		const bubbleAnchor = document.createElement('div');
		bubbleAnchor.classList.add('popup-bubble-anchor');
		bubbleAnchor.appendChild(contentDiv);

		this.containerDiv = document.createElement('div');
		this.containerDiv.classList.add('popup-container');
		this.containerDiv.appendChild(bubbleAnchor);
	}

	onAdd() {
		this.getPanes().floatPane.appendChild(this.containerDiv);
	}

	onRemove() {
		if (this.containerDiv.parentElement) {
			this.containerDiv.parentElement.removeChild(this.containerDiv);
		}
	}

	draw() {
		const divPosition = this.getProjection().fromLatLngToDivPixel(this.position);

		const display = Math.abs(divPosition.x) < 4000 && Math.abs(divPosition.y) < 4000 ? 'block' : 'none';

		if (display === 'block') {
			this.containerDiv.style.left = divPosition.x + 'px';
			this.containerDiv.style.top = divPosition.y - 50 + 'px';
		}
		if (this.containerDiv.style.display !== display) {
			this.containerDiv.style.display = display;
		}
	}

	getMouseEvents() {
		return this.clickEventSubject.asObservable();
	}
}
